<script setup>
import { ref } from 'vue'

const showModal = ref(false)
const showSubmitModal = ref(false)
const currentNeed = ref(null)
const introNote = ref('')
const submitNote = ref('')

function makeIntro() {
    showModal.value = true
}

function submitStartups(need) {
    currentNeed.value = need
    showSubmitModal.value = true
}
</script>

<template>
    <div class="dashboard-page">
        <aside class="dashboard-page__sidebar dashboard-page__sidebar--bordered">
            <h3 class="dashboard-page__title">Your network</h3>

            <div class="dashboard-page__gradient">
                <h3 class="dashboard-page__title">Contributor status</h3>
                <b class="dashboard-page__contributor">Top 10%</b>

                <p>Your recommendations are being reviewed and advanced by enterprise teams.</p>
            </div>

            <div class="dashboard-page__plate">
                <header class="dashboard-page__plate__header">
                    <h6 class="heading6 heading6--ecosystem">Your Contributions</h6>
                </header>
                <div class="dashboard-page__plate__content">
                    <ul class="dashboard-page__stat">
                        <li>
                            <big>32</big>
                            <p>solutions sent to 8<br/> different needs</p>
                        </li>
                    </ul>

                    <ul class="dashboard-page__seats-list">
                        <li>
                            <span class="dashboard-page__seats-list__title">Matched to need by user</span>

                            <div class="dashboard-page__seats-list__inner">
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 30%;" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span>75%</span>
                            </div>
                        </li>
                        <li>
                            <span class="dashboard-page__seats-list__title">Advanced to project</span>

                            <div class="dashboard-page__seats-list__inner">
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" style="width: 64%;" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <span>75%</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="dashboard-page__plate">
                <header class="dashboard-page__plate__header">
                    <h6 class="heading6 heading6--bell">Alerts</h6>
                </header>
                <div class="dashboard-page__plate__content pt-2">

                    <div class="dashboard-page__plate">
                        <div class="dashboard-page__plate__content d-flex">
                            <div>
                                <h6 class="heading6">Smart Packaging</h6>

                                <p class="mb-0">Weekly digest</p>
                            </div>

                            <a href="#" class="link-edit"></a>
                        </div>
                    </div>

                    <button class="button button--add">Create An Alert</button>
                </div>
            </div>

            <div class="dashboard-page__plate">
                <header class="dashboard-page__plate__header">
                    <h6 class="heading6 heading6--activity">Activity</h6>
                </header>

                <div class="dashboard-page__plate__content">
                    <ul class="dashboard-page__activity">
                        <li class="dashboard-page__activity__like">
                            <div>
                                <h6 class="heading6"><a href="#">Aithena</a> matched to</h6>
                                <p><a href="#">Biodegradable Plastic</a></p>
                            </div>
                            <time class="dashboard-page__activity__time">1d</time>
                        </li>
                        <li class="dashboard-page__activity__tracker">
                            <div>
                                <h6 class="heading6"><a href="#">Sigma Logistics</a></h6>
                                <p>Biodegradable Plastic</p>
                            </div>
                            <time class="dashboard-page__activity__time">2d</time>
                        </li>
                        <li class="dashboard-page__activity__upload">
                            <div>
                                <h6 class="heading6"><a href="#">Aithena</a> matched to</h6>
                                <p><a href="#">Biodegradable Plastic</a></p>
                            </div>
                            <time class="dashboard-page__activity__time">1d</time>
                        </li>
                        <li class="dashboard-page__activity__tracker">
                            <div>
                                <h6 class="heading6"><a href="#">Sigma Logistics</a></h6>
                                <p>Biodegradable Plastic</p>
                            </div>
                            <time class="dashboard-page__activity__time">2d</time>
                        </li>
                    </ul>

                    <!-- <div v-if="hasMore" class="text-center mt-3">
                        <a @click="page++" class="link">Load More</a>
                    </div> -->
                </div>
            </div>
        </aside>
        <main class="dashboard-page__main">
            <div class="dashboard-page__gradient dashboard-page__statistic-section">
                <header class="dashboard-page__statistic-section__header">
                    <div>
                        <h2 class="heading2">Budgeted enterprise needs your network can help solve</h2>

                        <p>Review active opportunities from enterprise sponsors, see where your portfolio is already a fit, and submit the startups most likely to move into review.</p>
                    </div>

                    <button class="button">Review Top Matches</button>
                </header>

                <ul class="dashboard-page__stat-grids">
                    <li>
                        <h3 class="dashboard-page__title">Active needs</h3>
                        <big>18</big> 
                        <p>Across pharma, insurance, fintech, retail, and more</p>
                    </li>
                    <li>
                        <h3 class="dashboard-page__title">High-fit matches</h3>
                        <big>9</big> 
                        <p>Needs where your portfolio has 90% alignment</p>
                    </li>
                    <li>
                        <h3 class="dashboard-page__title">Expiring soon</h3>
                        <big>5</big> 
                        <p>Prioritize these before the opoprtunity window closes</p>
                    </li>
                    <li>
                        <h3 class="dashboard-page__title">Advanced</h3>
                        <big>9</big> 
                        <p>Your recommendations moved to enterprise review</p>
                    </li>
                </ul>
            </div>

            <div class="dashboard-page__card dashboard-page__card--round">
                <div class="dashboard-page__card__inner">
                    <header class="dashboard-page__card__header">
                        <h3 class="dashboard-page__title dashboard-page__title--requests" title="6">Intro requests</h3>

                        <button class="button button--slim">View All Requests</button>
                    </header>

                    <div class="dashboard-page__plate">
                        <div class="dashboard-page__plate__content dashboard-page__plate__content--flex">
                            <div>
                                <h6 class="heading6 mb-2">Codewisp requested an intro</h6>

                                <div class="dashboard-page__status-plate-wrapper">
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--unreviewed dashboard-page__status-plate--score">75% Match</span>
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--in_progress">Smart Packaging</span>
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--in_progress">Fintech</span>
                                </div>
                            </div>

                            <div class="data-labels-set">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <button class="button button--arrow" @click="makeIntro">Make Intro</button>
                        </div>
                    </div>
                    <div class="dashboard-page__plate">
                        <div class="dashboard-page__plate__content dashboard-page__plate__content--flex">
                            <div>
                                <h6 class="heading6 mb-2">Codewisp requested an intro</h6>

                                <div class="dashboard-page__status-plate-wrapper">
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--unreviewed dashboard-page__status-plate--score">75% Match</span>
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--in_progress">Smart Packaging</span>
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--in_progress">Fintech</span>
                                </div>
                            </div>

                            <div class="data-labels-set">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <button class="button button--arrow" @click="makeIntro">Make Intro</button>
                        </div>
                    </div>
                    <div class="dashboard-page__plate">
                        <div class="dashboard-page__plate__content dashboard-page__plate__content--flex">
                            <div>
                                <h6 class="heading6 mb-2">Codewisp requested an intro</h6>

                                <div class="status-plate-wrapper">
                                    <span class="status-plate status-plate--slim status-plate--unreviewed status-plate--score">75% Match</span>
                                    <span class="status-plate status-plate--slim status-plate--in_progress">Smart Packaging</span>
                                    <span class="status-plate status-plate--slim status-plate--in_progress">Fintech</span>
                                </div>
                            </div>

                            <div class="data-labels-set">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <button class="button button--arrow" @click="makeIntro">Make Intro</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dashboard-page__anchors">
                <a href="#needs-escalated" class="dashboard-page__anchors__item active">Enterprise needs</a>
                <a href="#needs-non-escalated" class="dashboard-page__anchors__item">Submitted</a>
                <a href="#needs-archived" class="dashboard-page__anchors__item">Archived</a>
            </div>

            <div id="dashboard-page-escalated" class="dashboard-page__card dashboard-page__card--round">
                <div class="dashboard-page__card__inner">
                  <header class="dashboard-page__card__header">
                    <h3 class="dashboard-page__title dashboard-page__title--enterprise">Enterprise Needs</h3>

                    <div class="ml-auto">
                      <input type="text" placeholder="Search for a category" class="dashboard-page__search">
                    </div>
                  </header>
                  <div class="dashboard-page__filter--scroll-wrap">
                      <div class="dashboard-page__filter--scroll">
                        <span class="filter-item filter-item--recommended">Recommended</span>
                        <span class="filter-item filter-item--recent">Recent</span>
                        <span class="filter-item" title="14">Smart Packaging</span>
                        <span class="filter-item" title="8">Fintech</span>
                        <span class="filter-item" title="2">Healthcare</span>
                        <span class="filter-item" title="2">Crypto</span>
                        <span class="filter-item">Artificial Intelligence</span>
                        <span class="filter-item">Somthing else</span>
                      </div>
                  </div>
                </div>

                <div class="dashboard-page__table dashboard-page__table-flexible">
                  <table>
                    <thead>
                      <tr>
                        <th>INNOVATION NEED</th>
                        <th>CORPORATE SPONSOR</th>
                        <th>MATCH</th>
                        <th>WHY YOU'RE SEEING THIS</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                            <h6 class="heading6">Biocompatible Barrier Films</h6>
                            <p>Sustainable high-barrier compostable films for blister packaging</p>

                            <div class="dashboard-page__status-plate-wrapper">
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--danger">Expiring in 2 days</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">Smart Packaging</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">AI</span>
                            </div>
                        </td>
                        <td>
                          <div class="top-category top-category--pharma">Top 10 global pharma co</div>
                        </td>
                        <td><span class="dashboard-page__status-plate dashboard-page__status-plate--xs">95%</span></td>
                        <td>
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <p>
                                <b>3 strong fits</b><br/>
                                Your portfolio has materials, packaging, and enterprise deployment signals
                            </p>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <button class="button" @click="submitStartups()">Submit Startups</button>

                                <Dropdown right class="dropdown-original icons-list dropdown-small ml-auto text-right">
                                    <DropdownItem class="icons-list__edit">
                                        Edit Group
                                    </DropdownItem>

                                    <DropdownItem
                                        class="icons-list__delete"
                                    >
                                        Remove Group
                                    </DropdownItem>
                                </Dropdown>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h6 class="heading6">Tomato Production Startups</h6>
                          <p class="danger">Escalated 1 month ago</p>
                        </td>
                        <td>
                          <div class="top-category top-category--funding">Global Tier-1 Retail Bank</div>
                        </td>
                        <td><span class="dashboard-page__status-plate dashboard-page__status-plate--xs">95%</span></td>
                        <td>
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <p>
                                <b>4 strong fits</b><br/>
                                Your portfolio contains deep-tech cybersecurity, fintech infrastructure, and AML compliance tools.
                            </p>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <button class="button" @click="submitStartups()">Submit Startups</button>

                                <Dropdown right class="dropdown-original icons-list dropdown-small ml-auto text-right">
                                    <DropdownItem class="icons-list__edit">
                                        Edit Group
                                    </DropdownItem>

                                    <DropdownItem
                                        class="icons-list__delete"
                                    >
                                        Remove Group
                                    </DropdownItem>
                                </Dropdown>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h6 class="heading6">Tomato Production Startups</h6>
                          <p class="danger">Escalated 1 month ago</p>
                        </td>
                        <td>
                          <div class="top-category top-category--boitech">Top 5 Global Biotech Firm</div>
                        </td>
                        <td><span class="dashboard-page__status-plate dashboard-page__status-plate--xs">95%</span></td>
                        <td>
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <p>
                                <b>2 strong fits</b><br/>
                                Your portfolio includes digital health, remote monitoring, and patient-centric SaaS.
                            </p>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <button class="button" @click="submitStartups()">Submit Startups</button>

                                <Dropdown right class="dropdown-original icons-list dropdown-small ml-auto text-right">
                                    <DropdownItem class="icons-list__edit">
                                        Edit Group
                                    </DropdownItem>

                                    <DropdownItem
                                        class="icons-list__delete"
                                    >
                                        Remove Group
                                    </DropdownItem>
                                </Dropdown>
                            </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                            <h6 class="heading6">Biocompatible Barrier Films</h6>
                            <p>Sustainable high-barrier compostable films for blister packaging</p>

                            <div class="dashboard-page__status-plate-wrapper">
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--danger">Expiring in 2 days</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">Smart Packaging</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">AI</span>
                            </div>
                        </td>
                        <td>
                          <div class="top-category top-category--pharma">Top 10 global pharma co</div>
                        </td>
                        <td><span class="dashboard-page__status-plate dashboard-page__status-plate--xs">95%</span></td>
                        <td>
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <p>
                                <b>9 strong fits</b><br/>
                                Your portfolio has materials, packaging, and enterprise deployment signals
                            </p>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <button class="button" @click="submitStartups()">Submit Startups</button>

                                <Dropdown right class="dropdown-original icons-list dropdown-small ml-auto text-right">
                                    <DropdownItem class="icons-list__edit">
                                        Edit Group
                                    </DropdownItem>

                                    <DropdownItem
                                        class="icons-list__delete"
                                    >
                                        Remove Group
                                    </DropdownItem>
                                </Dropdown>
                            </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>

            <div id="dashboard-page-escalated" class="dashboard-page__card dashboard-page__card--round">
                <div class="dashboard-page__card__inner">
                  <header class="dashboard-page__card__header">
                    <h3 class="dashboard-page__title dashboard-page__title--submitted">Submitted</h3>

                    <div class="ml-auto">
                      <input type="text" placeholder="Search for a need" class="dashboard-page__search">
                    </div>
                  </header>
                </div>

                <div class="dashboard-page__table dashboard-page__table-flexible">
                  <table>
                    <thead>
                      <tr>
                        <th>Submitted Startup</th>
                        <th class="dashboard-page__table__descr">Need</th>
                        <th>Corporate Sponsor</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="dashboard-page__table__title">
                                    <div class="data-labels-set data-labels-set--xs">
                                        <span class="data-label data-label--lightning"></span>
                                    </div>
                                    <h6 class="heading6"><a href="#">Sigma Logistics</a></h6>
                                </div>
                            </td>
                            <td>
                                <h6 class="heading6"><a href="#">Biocompatible Barrier Films</a></h6>
                                <p>Sustainable high-barrier compostable films for blister packaging</p>
                            </td>
                            <td>
                                <div class="top-category top-category--boitech">Top 5 Global<br/> Biotech Firm</div>
                            </td>
                            <td>
                                <div class="dashboard-page__status-plate-wrapper">
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--unreviewed dashboard-page__status-plate--bold">In Review</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="dashboard-page__table__title">
                                    <div class="data-labels-set data-labels-set--xs">
                                        <span class="data-label data-label--lightning"></span>
                                    </div>
                                    <h6 class="heading6"><a href="#">Sigma Logistics</a></h6>
                                </div>
                            </td>
                            <td>
                                <h6 class="heading6"><a href="#">Biocompatible Barrier Films</a></h6>
                                <p>Sustainable high-barrier compostable films for blister packaging</p>
                            </td>
                            <td>
                                <div class="top-category top-category--boitech">Top 5 Global<br/> Biotech Firm</div>
                            </td>
                            <td>
                                <div class="dashboard-page__status-plate-wrapper">
                                    <span class="dashboard-page__status-plate dashboard-page__status-plate--slim dashboard-page__status-plate--bold">Added To Need</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>

            <div id="dashboard-page-escalated" class="dashboard-page__card dashboard-page__card--round">
                <div class="dashboard-page__card__inner">
                  <header class="dashboard-page__card__header">
                    <h3 class="dashboard-page__title dashboard-page__title--archived">Archived Needs</h3>

                    <div class="ml-auto">
                      <input type="text" placeholder="Search for a category" class="dashboard-page__search">
                    </div>
                  </header>
                  
                </div>

                <div class="dashboard-page__table dashboard-page__table-flexible">
                  <table>
                    <thead>
                      <tr>
                        <th>INNOVATION NEED</th>
                        <th>CORPORATE SPONSOR</th>
                        <th>MATCH</th>
                        <th>WHY YOU'RE SEEING THIS</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                            <h6 class="heading6">Biocompatible Barrier Films</h6>
                            <p>Sustainable high-barrier compostable films for blister packaging</p>

                            <div class="dashboard-page__status-plate-wrapper">
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--danger">Expiring in 2 days</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">Smart Packaging</span>
                                <span class="dashboard-page__status-plate dashboard-page__status-plate--xs dashboard-page__status-plate--in_progress">AI</span>
                            </div>
                        </td>
                        <td>
                          <div class="top-category top-category--pharma">Top 10 global pharma co</div>
                        </td>
                        <td><span class="dashboard-page__status-plate dashboard-page__status-plate--xs">95%</span></td>
                        <td>
                            <div class="data-labels-set data-labels-set--xs">
                                <span class="data-label data-label--lightning"></span>
                                <span class="data-label data-label--pharma"></span>
                            </div>

                            <p>
                                <b>3 strong fits</b><br/>
                                Your portfolio has materials, packaging, and enterprise deployment signals
                            </p>
                        </td>
                        <td>
                            <button class="button" @click="submitStartups()">Submit Startups</button>
                        </td>
                        <td>
                            <Dropdown right class="dropdown-original icons-list dropdown-small ml-auto text-right">
                                <DropdownItem class="icons-list__edit">
                                    Edit Group
                                </DropdownItem>

                                <DropdownItem
                                    class="icons-list__delete"
                                >
                                    Remove Group
                                </DropdownItem>
                            </Dropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>
        </main>


        <Modal v-model="showModal" title="Introduce AlphaSource" modal-class="modal-v2 modal-intro">
            <p>Jordan L. (CEO) from <a href="#" class="link">AlphaSource</a> requested an introduction for a need:</p>

            <p><i>Tempus urna et pharetra pharetra. Sem integer vitae justo eget magna. Gravida cum sociis natoque penatibus et magnis. Nisi vitae suscipit tellus mauris a diam maecenas sed. Netus et malesuada fames ac turpis egestas sed.</i></p>

            <div class="contrast-plate">
                <header class="contrast-plate__header">
                    <div class="top-type">Top 10 global pharma co</div>

                    <!-- I'm pretty sure that there should be 3 colors here. So, we have next: match-rate--low, just match-rate (always in use!) and match-rate--high -->
                    <span class="match-rate match-rate--high">97% match</span>
                </header>

                <h6 class="heading6"><a href="#">Biocompatible Barrier Films</a></h6>

                <p>Sustainable high-barrier compostable films for blister packaging</p>

                <div class="status-plate-wrapper">
                    <span class="status-plate status-plate--xs status-plate--basic">Smart Packaging</span>
                    <span class="status-plate status-plate--xs status-plate--basic">AI</span>
                </div>
            </div>

            <h6 class="heading6 heading6--upper">Introduction note <small class="heading6__sub">(Recommended)</small></h6>

            <div class="note-lightning">
                <div class="note-lightning__inner">
                    <p>Add a note explaining why this startup is a good fit for this enterprise to strengthen your introduction. Try including:</p>

                    <ul class="list-check list-check--cols">
                        <li>Recent traction (new clients, pilots, revenue growth)</li>
                        <li>Strategic shifts (pivots, new markets)</li>
                        <li>Upcoming milestones (fundraising, product launches)</li>
                        <li>Relevant standout team experience</li>
                    </ul>
                </div>
            </div>

            <form action="" class="form-v2">
                <textarea v-model="introNote" class="form-control" placeholder="Share your perspective on this startup’s value, its key strengths, relevant experiences, or any other context that might be helpful"></textarea>
            </form>

            <template #modal-footer>
                <Button class="ui-button ui-button--xl ui-button--bordered">Dismiss Request</Button>
                <Button class="ui-button ui-button--xl" :disabled="!introNote.trim()">Make Intro</Button>
            </template>
        </Modal>

        <Modal v-model="showSubmitModal" title="Submit AlphaSquare To This Need" modal-class="modal-v2 modal-submit">
            <div class="modal__plate">
                <div>
                    <div class="data-labels-set">
                        <span class="data-label data-label--lightning"></span>

                        <h6 class="heading6"><a href="#">Sigma Logistics</a></h6>
                    </div>
                </div>

                <div class="status-plate-wrapper">
                    <span class="status-plate status-plate--unreviewed status-plate--lg">Smart Packaging</span>
                    <span class="status-plate status-plate--unreviewed status-plate--lg">Artificial Intelligence</span>
                </div>

                <span class="match-rate match-rate--high match-rate--lg">97% match</span>
            </div>

            <h6 class="heading6 heading6--upper">Submission note <small class="heading6__sub">(Recommended)</small></h6>

            <div class="note-lightning">
                <div class="note-lightning__inner">
                    <p>Add a note explaining why this startup is a good fit for this enterprise to strengthen your introduction. Try including:</p>

                    <ul class="list-check">
                        <li>Recent traction (new clients, pilots, revenue growth)</li>
                        <li>Strategic shifts (pivots, new markets)</li>
                        <li>Upcoming milestones (fundraising, product launches)</li>
                        <li>Relevant standout team experience</li>
                    </ul>
                </div>
            </div>

            <form action="" class="form-v2">
                <textarea v-model="submitNote" class="form-control" placeholder="Share your perspective on this startup’s value, its key strengths, relevant experiences, or any other context that might be helpful"></textarea>
            </form>

            <template #modal-footer>
                <Button class="ui-button ui-button--xl" :disabled="!submitNote.trim()">Submit</Button>
            </template>
        </Modal>
    </div>
</template>

<style scoped>

</style>
